module.exports = __webpack_public_path__ + "static/media/antihumidity_advantages.67bebda4.jpg";